import React from 'react';

import { Card } from 'react-bootstrap';
import { Chart, CommonSeriesSettings, Series, Export, ArgumentAxis, Margin, Legend, Tooltip, Grid, Label } from 'devextreme-react/chart';

import { getCategoryFromOrigin } from "../helpers/requestHandler";
import { exportData, renderFullScreen } from '../helpers/utils';

const axisTitles = [
    { value: 'count', name: 'Active Users' },
];

export const updateUsersInstance = () => {
    window.lineChartHistoricUsers.loadData();
}

export const updateUsersRange = () => {
  window.lineChartHistoricUsers.loadData();
}

class lineChartMonthlyUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            getDataFD: '',
            getDataAC: '',
            getDataRB: '',
            getDataSH: '',
            combinedData: [] // Add combinedData to the initial state
        };
        window.lineChartHistoricUsers = this;
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {
    this.setState({
        getDataFD: [],
        getDataAC: [],
        getDataRB: [],
        getDataSH: []
    });

    try {
        let respFD = await getCategoryFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetMonthlyCountByCategory", 1) || [];
        let respAC = await getCategoryFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetMonthlyCountByCategoryAcademy", 3) || [];
        let respRB = await getCategoryFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetMonthlyCountByCategoryReachback", 5) || [];
        let respSH = await getCategoryFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetMonthlyCountByCategoryShopify", 6) || [];

        let combinedData = respFD.map(item => ({
            period: item.period,
            countFD: item.count,
            countAC: respAC.find(acItem => acItem.period === item.period)?.count || 0,
            countRB: respRB.find(rbItem => rbItem.period === item.period)?.count || 0,
            countSH: respSH.find(shItem => shItem.period === item.period)?.count || 0,
        }));

        this.setState({
            getDataFD: respFD,
            getDataAC: respAC,
            getDataRB: respRB,
            getDataSH: respSH,
            combinedData: combinedData 
        });
    } catch (error) {
        console.error("Error loading data:", error);
    }
}

  

    render() {
        if (this.state.combinedData.length > 0) {  
            return (
                <Card className="rounded-4">
                    <Card.Body>
                        <Card.Title>
                            Monthly Users
                            <div className='float-end'>
                                <span className="fullscreen-link" onClick={() => {renderFullScreen("#lineChartMonthlyUsers")}}>Full Screen</span>
                                <span> | </span>
                                <span className="fullscreen-link" onClick={() => {exportData("MonthlyUsers", this.state.combinedData)}}>Export</span>
                            </div>
                        </Card.Title>
                        <Card.Subtitle>
                            Number of Active User Logins by Month for ALL instances
                        </Card.Subtitle>
                        <Chart
                            id="lineChartMonthlyUsers"
                            palette="Violet"
                            dataSource={this.state.combinedData}
                            title="Monthly Active Users"
                        >
                            <CommonSeriesSettings
                                argumentField="period"
                                type="line"
                            />
                            {/* Series for each dataset */}
                            <Series
                                valueField="countFD"
                                name="FD"
                                color="blue"
                            />
                            <Series
                                valueField="countAC"
                                name="AC"
                                color="green"
                            />
                            <Series
                                valueField="countRB"
                                name="RB"
                                color="red"
                            />
                            <Series
                                valueField="countSH"
                                name="SH"
                                color="purple"
                            />

                            <Margin bottom={20} />
                            <Tooltip
                                enabled={true}
                                location="edge"
                                customizeTooltip={this.customizeTooltip.bind(this)}  // Ensure correct `this` context
                                zIndex={10000}
                            />
                            <ArgumentAxis
                                valueMarginsEnabled={false}
                                discreteAxisDivisionMode="crossLabels"
                            >
                                <Label
                                    wordWrap="break"
                                    overlappingBehavior="rotate"
                                />
                                <Grid visible={true} />
                            </ArgumentAxis>
                            <Legend
                                visible={true}
                            />
                            <Export enabled={true} />
                        </Chart>
                    </Card.Body>
                </Card>
            );
        }
        return 'No data retrieved';
    }

    customizeTooltip(arg) {
        return {
            text: `${arg.argumentText} Sign-Ins: ${arg.valueText}`,
        }
    }
}

export default lineChartMonthlyUsers;
